import React from 'react';

import { IoArrowBack } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';

import FormAddNewVehicle from '@components/forms/FormAddNewVehicle';
import {
  SubtitleSecondary,
  ButtonDefault,
  MenuSideBarPrivate,
  HeaderNavigationPrivate,
} from '@components/index';

import {
  Container,
  ContainerGroup,
  Content,
  Options,
  OptionsGroup,
} from './styles';

const AddNewVehicle: React.FC = () => {
  const { goBack } = useHistory();

  const handleGoBack = () => {
    goBack();
  };

  return (
    <Container>
      <HeaderNavigationPrivate />
      <ContainerGroup>
        <MenuSideBarPrivate />
        <Content>
          <SubtitleSecondary textAlign="start">
            Adicione um novo modelo veicular
          </SubtitleSecondary>
          <Options>
            <OptionsGroup>
              <ButtonDefault iconLeft={IoArrowBack} onClick={handleGoBack} />
            </OptionsGroup>
          </Options>
          <FormAddNewVehicle />
        </Content>
      </ContainerGroup>
    </Container>
  );
};

export default AddNewVehicle;
